module.exports = __webpack_public_path__ + "img/mastercard.648abd71.svg";